import ILogin from "../../models/ILogin";

export const loginState: ILogin = {
	Email: "",
	Password: ""
}
